import { buildDefaultMiddleware } from 'utilities/state';

export default buildDefaultMiddleware('theme', 'store:theme');